import * as React from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
configure({ enforceActions: 'observed', isolateGlobalState: true });

import { Provider } from 'mobx-react';
import { MainStore } from './stores/MainStore';
import { IContextData } from './stores/types';
import DetailsPageLayout from './components/detailsPage/detailsPageLayout';
import './thirdPartyStyles/styles';
import { installConsoleOverlay } from './helper/consoleOverlay';
import { logPageLoad, cleanupUrl } from './helper/init-helper';
/* eslint-disable no-console */

function hydrateApp() {
    const state = JSON.parse(JSON.stringify(window.__PRELOADED_PDP_STATE__));
    const store: MainStore = new MainStore(state.otherData, state.localization);
    delete window.__PRELOADED_PDP_STATE__;
    const container = document.getElementById('product-details-page-entry');

    if (!container) {
        throw new Error('product-details-page-entry root container element not found');
    }

    if (container) {
        ReactDOM.hydrate(
                <Provider
                    store={store}
                    orderModuleStore={store.orderModuleStore}
                    mixedMediaStore={store.mixedMediaStore}
                    variantStore={store.variantStore}
                    workWearStoreStore={store.workWearStoreStore}
                    dataStore={store.dataStore}
                >
                    <DetailsPageLayout />
                </Provider>, container
        );
    }
}

const state = JSON.parse(JSON.stringify(window.__PRELOADED_PDP_STATE__));
const context: IContextData = state.otherData.contextData;
if (context.isEsApp && !context.isRelease) {
    installConsoleOverlay({ openOnError: false, addTripleTapToToggle: true });
}

if (context.featureToggles.enableContentServiceForPDP) {
    try {
        // should not block the main part
        logPageLoad(state.otherData);
        cleanupUrl();
    } catch (e) {
        // ignored
        console.warn('detail page init exception: ' + e.message);
    }
}

try {
    hydrateApp();
} catch (e) {
    console.error('HYDRATION CRASH: ' + e.message);
}


